module.exports = __webpack_public_path__ + "static/media/file-regular~eJPHbTuX.1f89d962.svg";